import { useTheme } from '@infominds/react-native-components'
import * as React from 'react'
import {
  Text as DefaultText,
  TextInput as DefaultTextInput,
  TouchableHighlight as DefaultTouchableHighlight,
  TouchableOpacity as DefaultTouchableOpacity,
  View as DefaultView,
} from 'react-native'

import Colors from '../constants/Colors'

export function useThemeColor(props: { light?: string; dark?: string }, colorName: keyof typeof Colors.light & keyof typeof Colors.dark) {
  const { colorScheme } = useTheme()
  const colorFromProps = props[colorScheme]

  if (colorFromProps) {
    return colorFromProps
  } else {
    return Colors[colorScheme][colorName]
  }
}

type ThemeProps = {
  lightColor?: string
  darkColor?: string
}

export type TextProps = ThemeProps & DefaultText['props']
export type ViewProps = ThemeProps & DefaultView['props']
export type TouchableOpacityProps = ThemeProps & DefaultTouchableOpacity['props']
export type TouchableHighlightProps = ThemeProps & DefaultTouchableHighlight['props']
export type TextInputProps = ThemeProps & DefaultTextInput['props']

export function Text(props: TextProps) {
  const { style, lightColor, darkColor, ...otherProps } = props
  const color = useThemeColor({ light: lightColor, dark: darkColor }, 'text')

  return <DefaultText style={[{ color }, style]} {...otherProps} />
}

export function View(props: ViewProps) {
  const { style, lightColor, darkColor, ...otherProps } = props
  const backgroundColor = useThemeColor({ light: lightColor, dark: darkColor }, 'background')

  return <DefaultView style={[{ backgroundColor }, style]} {...otherProps} />
}

export function TouchableOpacity(props: TouchableOpacityProps) {
  const { style, lightColor, darkColor, ...otherProps } = props
  const backgroundColor = useThemeColor({ light: lightColor, dark: darkColor }, 'background')

  return <DefaultTouchableOpacity style={[{ backgroundColor }, style]} {...otherProps} />
}

export function TouchableHighlight(props: TouchableHighlightProps) {
  const { style, lightColor, darkColor, ...otherProps } = props
  const backgroundColor = useThemeColor({ light: lightColor, dark: darkColor }, 'background')

  return <DefaultTouchableHighlight style={[{ backgroundColor }, style]} {...otherProps} />
}

export function TextInput(props: TextInputProps) {
  const { style, lightColor, darkColor, ...otherProps } = props
  const backgroundColor = useThemeColor({ light: lightColor, dark: darkColor }, 'background')

  return <DefaultTextInput style={[{ backgroundColor }, style]} {...otherProps} />
}
